module.exports = __webpack_public_path__ + "static/img/shi5_2.a9dcf05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shi5_2.png
// module id = d6uZ
// module chunks = 1